import { useState } from "react";
import { MoveHorizontal } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const mediaUrl = (u) => (u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

const BeforeAfterSlider = ({ item, labels, testid = "before-after-slider" }) => {
  const [pos, setPos] = useState(50);

  return (
    <div className="group" data-testid={testid}>
      <div className="relative aspect-[4/3] select-none overflow-hidden rounded-3xl border border-brand/10 bg-mint shadow-lg shadow-brand/10">
        <img src={mediaUrl(item.after_url)} alt={`${labels.after} — ${item.caption}`} className="absolute inset-0 h-full w-full object-cover" draggable={false} />
        <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
          <img
            src={mediaUrl(item.before_url)}
            alt={`${labels.before} — ${item.caption}`}
            className="absolute inset-0 h-full max-w-none object-cover"
            style={{ width: `${10000 / pos}%` }}
            draggable={false}
          />
        </div>
        <div className="pointer-events-none absolute inset-y-0 w-1 -translate-x-1/2 bg-white shadow-[0_0_0_1px_rgba(30,138,76,0.3)]" style={{ left: `${pos}%` }}>
          <span className="absolute left-1/2 top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-gold text-white shadow-xl shadow-gold/40 transition-transform duration-300 group-hover:scale-110">
            <MoveHorizontal className="h-5 w-5" />
          </span>
        </div>
        <span className="pointer-events-none absolute left-4 top-4 rounded-full bg-forest/85 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-white">
          {labels.before}
        </span>
        <span className="pointer-events-none absolute right-4 top-4 rounded-full bg-gold px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-white">
          {labels.after}
        </span>
        <input
          type="range"
          min="1"
          max="99"
          value={pos}
          onChange={(e) => setPos(Number(e.target.value))}
          aria-label="Avant / Après"
          data-testid={`${testid}-range`}
          className="absolute inset-0 h-full w-full cursor-ew-resize appearance-none bg-transparent opacity-0"
        />
      </div>
      {item.caption && (
        <p className="font-display mt-4 text-base font-bold text-forest">{item.caption}</p>
      )}
    </div>
  );
};

export default BeforeAfterSlider;
